export const getIsRedisFlex = (plan: Plan, isBundledModules: boolean) => {
  return getIsRedisFlexEssentials(plan) || getIsRedisFlexPro(plan, isBundledModules);
};

export const getIsRedisFlexEssentials = (plan: Plan) => {
  return !!plan?.is_redis_flex;
};

export const getIsRedisFlexPro = (plan: Plan, isBundledModules: boolean) => {
  return !!(plan?.is_rof && isBundledModules);
};
